import { Instagram, Youtube, Facebook, Mail } from "lucide-react";
import Seo from "../components/Seo";
import ConciergeBand from "../components/ConciergeBand";

export default function About() {
  return (
    <main data-testid="about-page">
      <Seo title="About" path="/about" description="The Where To Go is a documentary travel guide intended to help you immerse yourself in different cultures, traditions and ways of life."/>
      <section className="max-w-8xl mx-auto px-6 md:px-12 pt-6 md:pt-10 pb-8 grid md:grid-cols-12 gap-10 border-b border-line">
        <div className="md:col-span-7">
          <div className="overline text-olive mb-5">About</div>
          <h1 className="font-serif text-5xl md:text-7xl leading-[0.95]">A field journal,<br/>not a brochure.</h1>
          <p className="mt-8 max-w-xl text-lg text-muted leading-relaxed">
            The Where To Go is a documentary travel guide intended to help you immerse yourself in different cultures, traditions, and ways of life, gaining a deeper understanding of the world around you.
          </p>
        </div>
        <div className="md:col-span-5">
          <img src="https://customer-assets.emergentagent.com/job_suspicious-visvesvaraya-7/artifacts/cjbz0mfo_WhatsApp%20Image%202025-07-04%20at%2023.11.02_ca176646%20SQ.jpg" alt="The Where To Go — brand mark" className="aspect-square object-contain w-full"/>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-6 py-10 md:py-12 prose-editorial">
        <h3 className="text-olive">What you'll find here</h3>
        <p>
          Real journeys through real places. These guides combine history, culture, architecture, transport, politics, and everyday life with honest on-site observations. No influencer clichés, luxury nonsense or recycled list articles. Just documentary-style travel writing, practical insight and the stories behind the places that people might easily miss out.
        </p>

        <h3 className="text-olive">The brief</h3>
        <p>
          Travel is more than just a journey; it's a transformative experience that enriches your life in countless ways. Travel raises cultural awareness, broadens perspectives and enriches your life. It allows you to experience different cultures, traditions and ways of life.
        </p>

        <h3 className="text-olive">Find me elsewhere</h3>
        <ul className="not-prose grid grid-cols-2 sm:grid-cols-4 gap-4 mt-4">
          <li>
            <a href="mailto:thewheretogo@btinternet.com" className="flex items-center gap-3 border border-line px-5 py-4 hover:border-olive hover:text-olive transition-colors" data-testid="about-email">
              <Mail size={18} strokeWidth={1.7}/>
              <span className="overline">Email</span>
            </a>
          </li>
          <li>
            <a href="https://www.youtube.com/@thewheretogo" target="_blank" rel="noreferrer" className="flex items-center gap-3 border border-line px-5 py-4 hover:border-olive hover:text-olive transition-colors" data-testid="about-youtube">
              <Youtube size={18} strokeWidth={1.7}/>
              <span className="overline">YouTube</span>
            </a>
          </li>
          <li>
            <a href="https://www.instagram.com/thewheretogo2025" target="_blank" rel="noreferrer" className="flex items-center gap-3 border border-line px-5 py-4 hover:border-olive hover:text-olive transition-colors" data-testid="about-instagram">
              <Instagram size={18} strokeWidth={1.7}/>
              <span className="overline">Instagram</span>
            </a>
          </li>
          <li>
            <a href="https://www.facebook.com/TheWhereToGo" target="_blank" rel="noreferrer" className="flex items-center gap-3 border border-line px-5 py-4 hover:border-olive hover:text-olive transition-colors" data-testid="about-facebook">
              <Facebook size={18} strokeWidth={1.7}/>
              <span className="overline">Facebook</span>
            </a>
          </li>
        </ul>
      </section>

      <ConciergeBand/>
    </main>
  );
}
